export const codeFormat = value =>
    parseInt(value).toLocaleString('en', {
    minimumIntegerDigits: 7,
    minimumFractionDigits: 0,
    useGrouping: false
  })

export const dateFormat = value =>
  value ? value.toString().slice(0, 10).split('-').reverse().join('-') : '-'

export const conditionalFormatValue = (
  value,
  truthValue = 'Si',
  falseValue = 'No'
) => (!!value ? truthValue : falseValue)

export const conditionalFormatText = (
  value,
  truthValue = 'Activo',
  falseValue = 'Inactivo'
) => (!!value ? truthValue : falseValue)

